function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161.2 161.2",
    style: {
      enableBackground: "new 0 0 161.2 161.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "#2C2C2C"
    },
    d: "M132.6,81.2c3.2,0,5.8,2.5,5.8,5.7l0,0.1v29.5c0,17-26.2,28.4-57.8,28.4 c-31.2,0-57.2-11.2-57.7-27.9l0-0.5V87.1c0-3.2,2.6-5.8,5.8-5.8c3.2,0,5.8,2.5,5.8,5.7l0,0.1v29.5c0,3.2,3.9,7.2,11.7,10.6 c8.9,3.9,21.2,6.1,34.4,6.1c13.2,0,25.5-2.3,34.4-6.1c7.7-3.3,11.6-7.3,11.7-10.5l0-0.1V87.1C126.8,83.8,129.4,81.2,132.6,81.2 L132.6,81.2z M87.2,20.2l69.7,33.1c2.2,1.1,3.2,3.7,2.1,6c-0.4,0.9-1.2,1.7-2.1,2.1l-1.6,0.8l-0.1,29.9c0,2.5-2,4.5-4.5,4.5 c-2.4,0-4.4-2-4.5-4.4l0-0.1l0.1-25.6L87.5,94.7c-4.3,2.1-9.3,2.1-13.6,0L4,61.4c-2.2-1.1-3.2-3.8-2.1-6c0.4-0.9,1.2-1.7,2.1-2.1 l69.7-33.1C78,18.1,82.9,18.1,87.2,20.2z M78.9,30.7l-0.1,0.1l-56,26.6L79,84.2c1.1,0.5,2.3,0.5,3.4,0.1l0.1-0.1l55.8-26.8 L82.2,30.7C81.1,30.2,79.9,30.2,78.9,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M80.7,142.2c-30.9,0-54.5-10.8-54.9-25.2l0-0.5V87.1c0-1.7,1.3-3,3-3c1.6,0,3,1.3,3,2.9l0,29.6 c0,4.7,4.9,9.5,13.4,13.2c9.4,4.1,22,6.4,35.5,6.4c13.5,0,26.1-2.3,35.5-6.4c8.5-3.7,13.3-8.3,13.4-13l0-29.7c0-1.7,1.3-3,3-3 c1.6,0,3,1.3,3,2.9v29.6C135.6,130.9,111.5,142.2,80.7,142.2z M150.7,93.7c-0.9,0-1.6-0.7-1.7-1.6l0.1-30.1L86.3,92.2 c-1.7,0.8-3.7,1.3-5.6,1.3c-1.9,0-3.8-0.4-5.6-1.3L5.2,58.8c-0.4-0.2-0.7-0.5-0.8-0.9S4.3,57,4.5,56.6c0.2-0.3,0.4-0.6,0.8-0.8 l69.7-33.1c1.7-0.8,3.6-1.2,5.5-1.2c1.9,0,3.8,0.4,5.5,1.2l69.7,33.1c0.4,0.2,0.7,0.5,0.9,0.9c0.1,0.4,0.1,0.9-0.1,1.3 c-0.2,0.3-0.4,0.6-0.8,0.8l-3.2,1.5l-0.1,31.7C152.4,93,151.6,93.7,150.7,93.7L150.7,93.7z M80.5,27.5c-0.9,0-1.9,0.2-2.7,0.6 l-0.2,0.1L16.1,57.4l61.6,29.4c0.9,0.4,1.9,0.7,3,0.7c1,0,1.9-0.2,2.8-0.6l0.2-0.1l61.2-29.4L83.4,28.2 C82.5,27.7,81.5,27.5,80.5,27.5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduate);
export default __webpack_public_path__ + "static/media/graduate.f86cebdd167550d3a3de19f3b7885d44.svg";
export { ForwardRef as ReactComponent };